import React, { PureComponent } from "react";
import { Form } from "react-bootstrap";
import styled from "styled-components";

const Container = styled.div`
  position: relative;
  margin-bottom: 10px;
`;

const Label = styled(Form.Label)`
  font-size: ${props => props.fontSize || "13px"};
  color: ${props => props.color || "#000000"};
  font-weight: ${props => props.fontWeight || "normal"};
  cursor: ${props => props.cursor || "default"};

  & span {
    color: red;
  }
`;

const InputContainer = styled.div`
  display: flex;
  gap: 5px;
`;

const OTPInput = styled.input`
  border: 1px solid #ced4da;
  border-radius: 4px;
  width: 40px;
  height: 40px;
  background-color: white;
  text-align: center;
  font-size: 18px;
  outline: none;

  &:focus {
    border-color: #86b7fe;
    box-shadow: 0 0 0 1px rgb(0 123 255 / 25%);
  }
`;

class PinInputField extends PureComponent {
  constructor(props) {
    super(props);

    const length = props.length || 6;

    this.state = {
      values: Array(length).fill("")
    };

    this.inputRefs = [];
  }

  handleChange = (event, index) => {
    const { onChange, onComplete } = this.props;
    const length = this.props.length || 6;

    // Only allow numbers
    const value = event.target.value.replace(/\D/g, "");

    const values = [...this.state.values];

    values[index] = value.slice(-1);

    this.setState({ values }, () => {
      const otp = values.join("");

      // Same purpose as react-pin-input onChange
      if (onChange) {
        onChange(otp, index);
      }

      // OTP completed
      if (
        otp.length === length &&
        !values.includes("")
      ) {
        if (onComplete) {
          onComplete(otp, index);
        }
      }
    });

    // Move cursor to next box
    if (value && index < length - 1) {
      this.inputRefs[index + 1]?.focus();
    }
  };

  handleKeyDown = (event, index) => {
    // Backspace -> move to previous box
    if (
      event.key === "Backspace" &&
      !this.state.values[index] &&
      index > 0
    ) {
      this.inputRefs[index - 1]?.focus();
    }
  };

  handlePaste = (event) => {
    event.preventDefault();

    const length = this.props.length || 6;

    // Get pasted OTP and allow numbers only
    const pastedValue = event.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, length);

    if (!pastedValue) {
      return;
    }

    const values = Array(length).fill("");

    pastedValue.split("").forEach((digit, index) => {
      values[index] = digit;
    });

    this.setState({ values }, () => {
      const otp = values.join("");

      if (this.props.onChange) {
        this.props.onChange(otp, pastedValue.length - 1);
      }

      if (
        pastedValue.length === length &&
        this.props.onComplete
      ) {
        this.props.onComplete(otp, length - 1);
      }
    });

    // Focus last filled box
    const focusIndex = Math.min(
      pastedValue.length,
      length
    ) - 1;

    if (focusIndex >= 0) {
      this.inputRefs[focusIndex]?.focus();
    }
  };

  render() {
    const {
      length = 6,
      label,
      isrequiredicon,
      className,
      parentClass,
      onClick
    } = this.props;

    return (
      <Container className={parentClass || className}>
        <Form.Group>

          {label && (
            <Label
              color={this.props.labelColor}
              fontWeight={this.props.labelFontWeight}
              cursor={this.props.labelCursor}
              onClick={onClick}
            >
              {label}{" "}
              {isrequiredicon ? <span>*</span> : ""}
            </Label>
          )}

          <InputContainer>
            {Array.from({ length }).map((_, index) => (
              <OTPInput
                key={index}
                ref={(element) => {
                  this.inputRefs[index] = element;
                }}
                type="text"
                inputMode="numeric"
                maxLength={1}
                value={this.state.values[index]}
                onChange={(event) =>
                  this.handleChange(event, index)
                }
                onKeyDown={(event) =>
                  this.handleKeyDown(event, index)
                }
                onPaste={this.handlePaste}
                autoFocus={index === 0}
                autoComplete="one-time-code"
              />
            ))}
          </InputContainer>

        </Form.Group>
      </Container>
    );
  }
}

export { PinInputField };